// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const drifblim: PokeData = {
  "id": 426,
  "name": "drifblim",
  "height": 12,
  "weight": 150,
  "base_experience": 174,
  "types": [
    PokeType.GHOST,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "confusion",
    "hypnosis",
    "minimize",
    "focus-energy",
    "self-destruct",
    "constrict",
    "amnesia",
    "explosion",
    "destiny-bond",
    "baton-pass",
    "shadow-ball",
    "stockpile",
    "spit-up",
    "swallow",
    "astonish",
    "extrasensory",
    "calm-mind",
    "tailwind",
    "payback",
    "ominous-wind",
    "hex",
    "phantom-force",
    "mystical-fire",
    "strength-sap"
  ],
  "moves": [
    "gust",
    "shadow-ball",
    "calm-mind",
    "tailwind",
    "phantom-force",
    "soul-sacrifice",
    "roost",
    "shadow-sneak",
    "curse",
    "peck",
    "shadow-dagger",
    "brave-bird",
    "poltergeist"
  ],
  "evolution_chain": {
    "id": 219,
    "item": null,
    "species": [
      {
        "name": "drifloon",
        "order": 452,
        "types": [
          PokeType.GHOST,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "drifblim",
        "order": 453,
        "types": [
          PokeType.GHOST,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 425,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 148,
    "speed": 119,
    "ability_power": 134
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
